import React from 'react'
import {Button, Menu, Typography, Avatar, Divider, List} from 'antd';
import { Link } from 'react-router-dom';
import { HomeOutlined, MoneyCollectOutlined, BulbOutlined, FundOutlined, MenuOutlined} from '@ant-design/icons'; 
import icon from '../images/crypto-logo.png';
import { AppBar, Box, CssBaseline, Drawer, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar } from '@mui/material';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import NewspaperIcon from '@mui/icons-material/Newspaper';
const drawerWidth = 0.2;

const navbarLinks = [
    {
        name: 'Home',
        path: '/',
        icon: <InboxIcon/>
    },
    {
        name: 'Cryptocurrencies',
        path: '/cryptocurrencies',
        icon: <CurrencyBitcoinIcon/>
    },
    {
        name: 'News',
        path: '/news',
        icon: <NewspaperIcon/>
    }
]

const Navbar = () => {
    return (
            <Box sx={{ display: 'flex' }}>

                <CssBaseline />
                    <Drawer
                        sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                        },
                        }}
                        variant="permanent"
                        anchor="left"
                    >
                        <List>
                        {navbarLinks.map((link, index) => (
                            <Link to={link.path}>            
                                <ListItem key={index} disablePadding>
                                <ListItemButton>
                                <ListItemIcon>
                                    {link.icon}
                                </ListItemIcon>
                                <ListItemText primary={link.name} />
                                </ListItemButton>
                            </ListItem>
                            </Link>

                        ))}
                        </List>
                        <Divider />
                    </Drawer>
            </Box>
    )
}

export default Navbar
